import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/global.service';
import { Service } from 'src/app/services';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-payment-shipping',
  templateUrl: './payment-shipping.component.html',
  styleUrls: ['./payment-shipping.component.sass']
})
export class PaymentShippingComponent implements OnInit {
  @Output() selectsToDisplayOut = new EventEmitter<any>();
  @Output() validate = new EventEmitter<boolean>();
  signupFormPay: FormGroup
  public changeVisa: boolean = false;
  public changeMC: boolean = false;
  public changeAmerican: boolean = false;
  public cardType: string = '';
  public text: boolean = false;
  public maxCvv: number = 4;
  public maxZip: number = 6;
  public selectsToDisplay: any;
  constructor(private builder: FormBuilder, public global: GlobalService, private loadingScreenService: LoadingScreenService, private services: Service, private router: Router) { }

  ngOnInit() {
    this.signupFormPay = this.builder.group({
      name: ['', Validators.required],
      numberCard: ['', [this.cardVerification]],
      month: ['', [Validators.required, Validators.minLength(2)]],
      year: ['', [Validators.required, Validators.minLength(2)]],
      zipCode: ['', Validators.required],
      cvv: ['', [Validators.required, Validators.minLength(this.maxCvv), Validators.maxLength(this.maxCvv)]]
    });
    this.global.tokenShop = sessionStorage.getItem("tokenShop");
  }

  cardVerification(control: FormControl): { [s: string]: boolean } {
    let expVisa = /^4\d{15}(\d{3})?$/;
    let expMaster = /^5[1-5][0-9]{14}$/;
    let expAmerican = /^3[47][0-9]{13}$/;
    if (expVisa.test(control.value)) {
      return null;
    }
    else if (expMaster.test(control.value)) {
      return null;
    }
    else if (expAmerican.test(control.value)) {
      return null;
    }
    else {
      return {
        testestCardt: true
      }
    }
  }
  validationPayment() {
    if (this.signupFormPay.status == "VALID") {
      this.validate.emit(true);
    }
    else {
      this.validate.emit(false);
    }
    if (this.signupFormPay.get('name').status == "INVALID") {
      this.global.notif(" Por favor, coloque el nombre del titúlar.");
      return
    }
    else if (this.signupFormPay.get('numberCard').status == "INVALID") {
      this.global.notif(" Por favor, coloque el número de la tarjeta.");
      return
    }
    else if (this.signupFormPay.get('month').status == "INVALID") {
      this.global.notif(" Por favor, coloque el mes de vencimiento de la tarjeta");
      return
    }
    else if (this.signupFormPay.get('year').status == "INVALID") {
      this.global.notif(" Por favor, coloque el año de vencimiento de la tarjeta");
      return
    }
    else if (this.signupFormPay.get('zipCode').status == "INVALID") {
      this.global.notif(" Por favor, ingrese el código postal");
      return
    }
    else if (this.signupFormPay.get('cvv').status == "INVALID") {
      this.global.notif(" Por favor, ingrese el CVV de la tarjeta");
      return
    }
    else {
      let arrayNumberCard: any;
      arrayNumberCard = Array.from(this.signupFormPay.get('numberCard')?.value);
      for (let i = 0; i < 12; i++) {
        arrayNumberCard.splice(0, 1);
      }
      this.selectsToDisplay = '|       ' + this.cardType + '    |     ' + 'xxxx xxxx xxxx ' + arrayNumberCard.join('');
      this.selectsToDisplayOut.emit(this.selectsToDisplay);
    }
  }
  validationCard(data) {
    this.cardType = data
    if (data == "Visa") {
      this.maxCvv = 3;
      this.changeVisa = true
      this.changeAmerican = false
      this.changeMC = false
    }
    else if (data == "Master") {
      this.maxCvv = 3;
      this.changeMC = true
      this.changeVisa = false
      this.changeAmerican = false
    }
    else if (data == "American") {
      this.maxCvv = 4;
      this.changeAmerican = true
      this.changeMC = false
      this.changeVisa = false
    }
    else if (data == "Invalid") {
      this.maxCvv = 3;
      this.changeAmerican = false
      this.changeMC = false
      this.changeVisa = false

    }
    this.signupFormPay = this.builder.group({
      name: [this.signupFormPay.get('name').value, Validators.required],
      numberCard: [this.signupFormPay.get('numberCard').value, [this.cardVerification]],
      month: [this.signupFormPay.get('month').value, [Validators.required, Validators.minLength(2)]],
      year: [this.signupFormPay.get('year').value, [Validators.required, Validators.minLength(2)]],
      zipCode: [this.signupFormPay.get('zipCode').value, Validators.required],
      cvv: [this.signupFormPay.get('cvv').value, [Validators.required, Validators.minLength(this.maxCvv), Validators.maxLength(this.maxCvv)]]
    });
  }
  ValidationZipCode(data) {
    if (data == "10") {
      this.maxZip = 11;

      this.signupFormPay = this.builder.group({
        name: [this.signupFormPay.get('name').value, Validators.required],
        numberCard: [this.signupFormPay.get('numberCard').value, [this.cardVerification]],
        month: [this.signupFormPay.get('month').value, [Validators.required, Validators.minLength(2)]],
        year: [this.signupFormPay.get('year').value, [Validators.required, Validators.minLength(2)]],
        zipCode: [this.signupFormPay.get('zipCode').value, [Validators.required, Validators.minLength(this.maxZip), Validators.maxLength(this.maxZip)]],
        cvv: [this.signupFormPay.get('cvv').value, [Validators.required, Validators.minLength(this.maxCvv), Validators.maxLength(this.maxCvv)]]
      });
    }
    if (data == "5") {
      this.maxZip = 5;

      this.signupFormPay = this.builder.group({
        name: [this.signupFormPay.get('name').value, Validators.required],
        numberCard: [this.signupFormPay.get('numberCard').value, [this.cardVerification]],
        month: [this.signupFormPay.get('month').value, [Validators.required, Validators.minLength(2)]],
        year: [this.signupFormPay.get('year').value, [Validators.required, Validators.minLength(2)]],
        zipCode: [this.signupFormPay.get('zipCode').value, [Validators.required, Validators.minLength(this.maxZip), Validators.maxLength(this.maxZip)]],
        cvv: [this.signupFormPay.get('cvv').value, [Validators.required, Validators.minLength(this.maxCvv), Validators.maxLength(this.maxCvv)]]
      });
    }
  }
  paymentGeneral(amount: number = 0, depositAmount: number = 0) {
    let account: any = JSON.parse(sessionStorage.getItem("accountInfo"));
    // let subs: any = JSON.parse(sessionStorage.getItem("subscriberInfo"));
    let email: string = account.emailField;
    let ban:number;
    if(sessionStorage.getItem("banExisting")!=null){
      ban= Number(String(sessionStorage.getItem("banExisting")));
    }
    else{
      ban= account.bANField;
    }
    let subscriber: string = sessionStorage.getItem("subscriberExisting");
    let typeCard: string = "";
    let zip: string = this.signupFormPay.get('zipCode')?.value + '-0000';
    typeCard = this.cardType;
    switch (typeCard) {
      case 'Visa':
        typeCard = 'V';
        break;
      case 'Master':
        typeCard = 'M';
        break;
      case 'American':
        typeCard = 'X';
        break;
    }
    this.loadingScreenService.startLoading();
    this.services.paymentIPTV(this.global.tokenShop, 8, this.signupFormPay.get('name')?.value, this.signupFormPay.get('numberCard')?.value, this.signupFormPay.get('cvv')?.value, typeCard, this.signupFormPay.get('month')?.value, '20' + this.signupFormPay.get('year')?.value, amount, email, ban, subscriber, zip, depositAmount).subscribe((data: any) => {
      this.loadingScreenService.stopLoading();
      if (data.hasError == false) {
        this.global.screenEnabled = true;
        this.router.navigate(['iptv_confirmation']);
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.errorDisplay);
      }
    });
  }
}
